import { Link, useNavigate } from 'react-router-dom';
import '../stylesheets/Journals.css';

export function Journals({ journals, deleteSingleJournal }) {
    const navigate = useNavigate();

    return (
        <div className='Journals'>
            <table border={1}>
                <thead>
                    <tr>
                        <th className='jorunalNumber'>N</th>
                        <th className='journalTitle'>Թերթի համար</th>
                        <th className='journalActions'>Գործողություններ</th>
                    </tr>
                </thead>

                <tbody>
                    {
                        journals.map((elem, index) => (
                            <tr className={elem.disabled ? '' : 'disabled'} key={elem._id}>
                                <td>{index + 1}</td>
                                <td>{elem.title}</td>
                                <td>
                                    <Link
                                        to={elem.disabled ? `/journals/${elem.url}` : ''}
                                        target={elem.disabled ? '_blank' : ''}
                                        className={elem.disabled ? 'active' : ''}
                                    >
                                        <i className='fa-solid fa-eye' />
                                    </Link>

                                    <i className='fa-solid fa-pen-to-square'
                                        onClick={() => navigate(`/admin/edit/journal/${elem._id}`)}
                                    />

                                    <i className='fa-solid fa-trash'
                                        onClick={() => deleteSingleJournal(elem._id)}
                                    />
                                </td>
                            </tr>
                        ))
                    }
                </tbody>
            </table>
        </div>
    )
}
